import $ from 'jquery';

const contact = function contact() {
  const $contactSelect = $('.gfield_select');
  const checkVal = val => {
    if (val && (val.target.value || val.target.value !== '')) {
      $contactSelect.removeClass('placeholder');
    } else {
      $contactSelect.addClass('placeholder');
    }
  };

  checkVal(null);
  if ($contactSelect && $contactSelect.length) {
    $contactSelect.on('change', ev => {
      checkVal(ev);
    });
  }
};
export default contact;



// WEBPACK FOOTER //
// ./src/scripts/modules/contact.js